import axios from 'axios';
import camelCase from 'camelcase-keys';
import { API_URL } from '@src/configs';

const axiosClient = axios.create({
  baseURL: `${API_URL}/api/v1`,
  responseType: 'json',
  timeout: 60 * 1000,
});

axiosClient.interceptors.request.use(
  (config) => {
    if (!navigator.onLine)
      return Promise.reject(new Error('No internet connection'));

    return config;
  },
  (error) => Promise.reject(error),
);

axiosClient.interceptors.response.use(
  (response) => camelCase(response.data, { deep: true }),
  (error) => Promise.reject(error),
);

export default axiosClient;
